import { Link } from "react-router-dom";
import { ArrowUpRight, Sprout } from "lucide-react";
import { Reveal, Eyebrow } from "./primitives";

export const FoundingSection = ({ anchorLink = false }) => (
    <section data-testid="founding-section" className="border-y border-[#E8E6E1] bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
            <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
                <div className="lg:col-span-5">
                    <Reveal>
                        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#1A3B2B] text-[#D9B96A]">
                            <Sprout size={24} aria-hidden="true" />
                        </span>
                        <Eyebrow className="mt-6">Founding Participants</Eyebrow>
                        <h2 className="font-display mt-4 text-3xl font-medium tracking-tight text-[#0A1711] sm:text-4xl">
                            Become a GGH Founding Participant
                        </h2>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <blockquote className="mt-8 border-l-2 border-[#C2A160] pl-6">
                            <p className="font-display text-xl italic leading-relaxed text-[#1A3B2B] md:text-2xl">
                                “You don't need to have all the answers. We are looking for people
                                and organizations willing to help us find better ones.”
                            </p>
                        </blockquote>
                    </Reveal>
                </div>
                <div className="lg:col-span-7">
                    <Reveal delay={0.1}>
                        <p className="text-base leading-relaxed text-[#4A5D54] md:text-lg">
                            GGH is inviting a small first group of hotels, researchers,
                            hospitality professionals, sustainability experts, technology
                            providers and strategic partners to help shape our early work.
                        </p>
                        <p className="mt-5 text-base leading-relaxed text-[#4A5D54] md:text-lg">
                            Founding participants may contribute through pilot participation,
                            research, technical knowledge, professional expertise, technology,
                            community insight or financial support.
                        </p>
                    </Reveal>
                    <Reveal delay={0.25}>
                        {anchorLink ? (
                            <a href="#interest-form" data-testid="founding-cta" className="btn-gold mt-9">
                                Become a Founding Participant
                                <ArrowUpRight size={16} aria-hidden="true" />
                            </a>
                        ) : (
                            <Link to="/get-involved#interest-form" data-testid="founding-cta" className="btn-gold mt-9">
                                Become a Founding Participant
                                <ArrowUpRight size={16} aria-hidden="true" />
                            </Link>
                        )}
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);
